import styles from "./ResultsStep.module.css";

import type { NetsuiteTransformResult } from "@/services/toolsService";

interface ResultsStepProps {
  result: NetsuiteTransformResult;
  onDownloadEmail: () => void;
  onDownloadSms: () => void;
  onReset: () => void;
}

export function ResultsStep({ result, onDownloadEmail, onDownloadSms, onReset }: ResultsStepProps) {
  const {
    rowsIn,
    emailContactsCount,
    smsContactsCount,
    dupesRemoved,
    rowsSkippedNoEmail,
    rowsSkippedNoPhone,
    roleBasedCount,
  } = result;

  return (
    <section className={styles.step} aria-labelledby="results-heading">
      <h2 id="results-heading" className={styles.heading}>
        Transform complete
      </h2>

      <dl className={styles.stats}>
        <div className={styles.statRow}>
          <dt>Rows processed</dt>
          <dd>{rowsIn.toLocaleString()}</dd>
        </div>
        <div className={styles.statRow}>
          <dt>Email contacts</dt>
          <dd>{emailContactsCount.toLocaleString()}</dd>
        </div>
        <div className={styles.statRow}>
          <dt>SMS contacts</dt>
          <dd>{smsContactsCount.toLocaleString()}</dd>
        </div>
        {dupesRemoved > 0 && (
          <div className={styles.statRow}>
            <dt>Duplicates removed</dt>
            <dd>{dupesRemoved.toLocaleString()}</dd>
          </div>
        )}
        {rowsSkippedNoEmail > 0 && (
          <div className={styles.statRow}>
            <dt>Skipped (no email)</dt>
            <dd>{rowsSkippedNoEmail.toLocaleString()}</dd>
          </div>
        )}
        {rowsSkippedNoPhone > 0 && (
          <div className={styles.statRow}>
            <dt>Skipped (no phone)</dt>
            <dd>{rowsSkippedNoPhone.toLocaleString()}</dd>
          </div>
        )}
        {roleBasedCount > 0 && (
          <div className={styles.statRow}>
            <dt>Role-based emails</dt>
            <dd>{roleBasedCount.toLocaleString()}</dd>
          </div>
        )}
      </dl>

      <div className={styles.actions}>
        <button type="button" className={styles.primary} onClick={onDownloadEmail}>
          Download email CSV
        </button>
        <button type="button" className={styles.primary} onClick={onDownloadSms}>
          Download SMS CSV
        </button>
      </div>

      <button type="button" className={styles.reset} onClick={onReset}>
        Process another file
      </button>
    </section>
  );
}
